import script from "./app-system-position-selector.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-system-position-selector.vue?vue&type=script&lang=ts&setup=true"

import "./app-system-position-selector.vue?vue&type=style&index=0&id=2eaf637c&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eaf637c"]])

export default __exports__